import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { useIsFetching } from "@tanstack/react-query";

import AccordionDropdown from "../../AccordionDropDown";

import FilterTable from "./FilterTable";
import DefaultTable from "./DefaultTable";

import withDocumentTitle from "../../withDocumentTitle";
import { TooltipInfoHover } from "../../Utility/TooltipInfoHover";
import { hasAccessToNetwork } from "../../../services/accountService";
import useDecodeToken from "../../../hooks/useDecodeToken";
// import { divisionCategories } from "../../../constants";

function CDKSettingsPage({ clientId }) {
  // const [divisionCategory, setDivisionCategory] = useState(
  //   divisionCategories.network
  // );
  const [decodedToken] = useDecodeToken();
  const isFetching = useIsFetching();
  const handleSubmitShipViaNetworkRef = useRef(null);
  const handleSubmitShipViaDedicatedRef = useRef(null);
  const handleSubmitCODRef = useRef(null);

  const handleSaveSettings = async () => {
    if (isFetching > 0) {
      toast.info("Data is still being processed. Please wait.", 2000);
      return;
    }

    handleSubmitCODRef.current?.handleOnSubmitCOD();
    handleSubmitShipViaNetworkRef.current?.handleOnSubmitShipVia();
    handleSubmitShipViaDedicatedRef.current?.handleOnSubmitShipVia();
  };

  return (
    <div className="mx-0 mx-lg-5">
      <AccordionDropdown
        className="mb-4"
        classNameTitle="font-semibold px-0"
        classNameCard="overflow-inherit"
        title="Settings"
        activeKey="cdk-settings-2"
      >
        <div className="px-md-3">
          <div className="row">
            <div className="col-lg-3 border-right">
              <h3 className="font-semibold text-center text-lg-left">
                Preferences
              </h3>
            </div>

            <div className="col-lg-9 mx-2 mx-lg-0">
              <div>
                <h3>
                  Filters
                  <TooltipInfoHover
                    iconStyleMerge={{ marginLeft: ".5rem", fontSize: "1.5rem" }}
                  >
                    You may set up filters for your orders here. <br />
                    By default all orders will be imported into the network
                    integration. <br />
                    If you wish to limit which orders are pulled or have orders
                    go to the dedicated integration, you may do so by setting
                    the appropriate values below.
                  </TooltipInfoHover>
                </h3>
              </div>

              <FilterTable
                className="m-0 mx-lg-4 my-lg-3 mx-xl-5"
                clientID={clientId}
                shipViaNetworkRef={handleSubmitShipViaNetworkRef}
                shipViaDedicatedRef={handleSubmitShipViaDedicatedRef}
              />
              {hasAccessToNetwork(decodedToken) && (
                <>
                  <h3>Defaults</h3>

                  <DefaultTable
                    className="m-0 mx-lg-4 my-lg-3 mx-xl-5"
                    codRef={handleSubmitCODRef}
                  />
                </>
              )}

              <div className="d-flex justify-content-end mt-3 mb-4 mx-lg-4 mx-xl-5">
                <button
                  type="button"
                  className="btn btn-lg btn-outline-primary"
                  onClick={handleSaveSettings}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </AccordionDropdown>
    </div>
  );
}

export default withDocumentTitle(CDKSettingsPage, {
  pageTitle: "CDK Settings",
});
